import posthog from 'posthog-js';

// Enhanced PostHog tracking utilities
// trackPageView function removed - using PostHog's automatic page view tracking instead

export const trackSectionView = (sectionName: string, additionalProps?: Record<string, any>) => {
  if (posthog && typeof posthog.capture === 'function') {
    posthog.capture('section_view', {
      section_name: sectionName,
      $current_url: window.location.href,
      timestamp: new Date().toISOString(),
      ...additionalProps,
    });
    console.log(`PostHog: Section view tracked - ${sectionName}`);
  }
};

export const trackButtonClick = (buttonName: string, location: string, additionalProps?: Record<string, any>) => {
  if (posthog && typeof posthog.capture === 'function') {
    posthog.capture('button_click', {
      button_name: buttonName,
      location: location,
      $current_url: window.location.href,
      timestamp: new Date().toISOString(),
      ...additionalProps,
    });
    console.log(`PostHog: Button click tracked - ${buttonName} at ${location}`);
  }
};

export const trackFormSubmission = (formName: string, success: boolean, additionalProps?: Record<string, any>) => {
  if (posthog && typeof posthog.capture === 'function') {
    posthog.capture('form_submission', {
      form_name: formName,
      success: success,
      $current_url: window.location.href,
      timestamp: new Date().toISOString(),
      ...additionalProps,
    });
    console.log(`PostHog: Form submission tracked - ${formName} (${success ? 'success' : 'failed'})`);
  }
};

export const trackNavigation = (toUrl: string, method: string = 'click') => {
  if (posthog && typeof posthog.capture === 'function') {
    posthog.capture('navigation', {
      from_url: window.location.href,
      to_url: toUrl,
      method: method,
      timestamp: new Date().toISOString(),
    });
    console.log(`PostHog: Navigation tracked - to ${toUrl} via ${method}`);
  }
};

// Using PostHog's default page names - no custom page name constants needed

// Section name constants
export const SECTION_NAMES = {
  HERO: 'Hero Section',
  FEATURES: 'Features Section',
  HOW_IT_WORKS: 'How It Works Section',
  USE_CASES: 'Use Cases Section',
  TESTIMONIALS: 'Testimonials Section',
  STAY_UPDATED: 'Stay Updated Section',
  HEADER: 'Header',
  FOOTER: 'Footer',
} as const;

// DIY Buddy specific constants
export const DIY_OPTIONS = {
  APPLIANCE_INSTRUCTIONS: 'applianceInstructions',
  IDENTIFY_PART: 'identifyPart',
  DIAGNOSE: 'diagnose',
} as const;

export const DIY_OPTION_LABELS = {
  [DIY_OPTIONS.APPLIANCE_INSTRUCTIONS]: 'Appliance Instructions',
  [DIY_OPTIONS.IDENTIFY_PART]: 'Identify Part',
  [DIY_OPTIONS.DIAGNOSE]: 'Troubleshoot/Repair',
} as const;

export const DIY_STATES = {
  ISSUE_OPTIONS: 'issueOptions',
  ISSUE_CHAT: 'issueChat',
} as const;
